import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTodaysBirthdays, loadUpcomingBirthdays } from '../../redux/rtk/features/user/userSlice';
import UpcomingBirthdaysModal from './upcomingBirthday';

const BirthdayBar = () => {
  const dispatch = useDispatch();
  const todaysBirthdays = useSelector((state) => state.users.todaysBirthdays);
  const upcomingBirthdays = useSelector((state) => state.users.upcomingBirthdays);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    dispatch(loadTodaysBirthdays());
  }, [dispatch]);

  const handleShowUpcomingBirthdays = () => {
    dispatch(loadUpcomingBirthdays()).then(() => {
      setModalVisible(true);
    });
  };

  return (
    <div className="birthday-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        {todaysBirthdays && todaysBirthdays.length > 0 ? (
          <ul>
            {todaysBirthdays.map((user) => (
              <li key={user.id}>
                {user.firstName} {user.lastName}
              </li>
            ))}
          </ul>
        ) : (
          <p>No birthdays today.</p>
        )}
      </div>
      <Button onClick={handleShowUpcomingBirthdays}>
        Upcoming Birthdays
      </Button>
      <UpcomingBirthdaysModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        upcomingBirthdays={upcomingBirthdays}
      />
    </div>
  );
};

export default BirthdayBar;
